<template>
    <div id="userLogin">
        <div>
            <div class="big-img">
                <img src="./../../assets/shenma-big.jpg" alt="" class="yema-big-img">
            </div>
            <h2>
                <!-- <img src="./../../assets/yema.jpg" alt="" class="yema-img"> -->
                <span>请输入账号查询</span>
            </h2>
            <form>        
                <div>
                    <keep-alive>
                        <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch"  @select="handleSelect" placeholder="请输入账号查询"></se-autocomplete>
                    </keep-alive>
                </div>
                <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询</mt-button> 
                </div>     
                 <!-- <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIMS">APP下载</mt-button> 
                </div> -->
                <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="userQuerySIM1">联系客服</mt-button> 
                </div>
  
            </form>

              
        </div>
         <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/loginlog.jpg"
      alt=""
     /> -->
        <!--    @click="goto('http://szyanyun.com/download.html')" --> 
        <!-- <mt-button type="primary"  style="width:200px;margin:50px auto;" size="large" @click.prevent="goBuyCard">点击此处购卡</mt-button> -->

        <!-- <img style="width: 100%; margin-top: 2rem;" src="@/assets/advertising1.jpg" alt="" @click="goto('https://mp.weixin.qq.com/s/y0FifxzADSlj9yETKjpbtA')" /> -->
                
       <!-- <Advertisement></Advertisement> -->
    </div>
    
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js' 
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
    components: {SeAutocomplete,Advertisement},
    data(){
        return {
            iccid: '',
            code: '',
            showAds: true,
            gzh:'',
            realNameList: ['1192351241053663232', '1224969664338063360', '1255666672321163264', '7DA692EC992B45E297450F40DEDC5614', '8601954A2B074E80AACAAF32C5EE232C', 
            '960F3276EFAA4ED2999754895F4BCCB4', 'B1E112B9F1D8420E9072D9F47D6A135E', '1275705014286807040', 
            '1275706083402313728', '1274979554988912640', '1279289937396494336','1354311436448296960'],
            suolangList: ['1275704520822747136']
        }
    },
    methods: { 
          userQuerySIMS(){
                    this.$router.replace('/user/AppLoad');
        }   ,
          userQuerySIM2(){
              window.location.href='http://xx.ywwltx.com/#/agent/login';
                    // this.$router.push({
                    //                     path:'/agent/login',
                    //                     query:{
                    //                     }
                    //                 });
        },
        userQuerySIM1(){
                window.location.href='http://kf.xxwlk.com/s/592566y71'
        }   ,
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');         
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;      
            cb(results);      
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item){
            this.iccid = item
        },       
        userQuerySIM(){

            if(this.iccid == ''){
                Dialog.alert({title: '提示', message:'请输入ICCID号'})
                return false;
            }

            let recordLoginText = this.iccid;//存放用户登录时输入的文本，将用于首页显示

            let data = {
                requestId: this.iccid,
                code: this.code,
                type:2
            }
			wxRequest("sim/bind",data, "get").then(res => {
                if(res.data.code == 200){
                    let record = res.data.data;
                    let iccid = record.iccid;
                    
					localStorage.setItem('mobile', record.mobile);
                    localStorage.setItem('supplierTypeName', record.supplierTypeName);
                    localStorage.setItem('wxHeadImg', record.wxHeadImg);
                    localStorage.setItem('wxNickName', record.wxNickName);
                    localStorage.setItem('recordLoginText', recordLoginText);
                    localStorage.setItem('supplierName', record.supplierName);
                    localStorage.setItem('iccid', iccid);
                    localStorage.setItem('app', 'app');


                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;                 
                    this.$store.state.iccid = iccid;

                    this.$store.state.intoNo = record.intoNo;
                    this.setAutoCompleteData('iccidList', recordLoginText, 10)
                    //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    let cardType = record.supplierCode;
                    if(this.realNameList.indexOf(cardType) > -1){
                        let _data = { iccid: record.iccid }
                        wxRequest("bindPhone/state", _data, "post").then(res => {
                            if(res.data.code == 200){
                                let result = res.data.data;
                                localStorage.setItem('applyChangeSimState', result.applyChangeSimState);
                                if(result.bindState == 2){
                                    this.$router.push({
                                        path:'/user/bindPhone',
                                        query:{
                                            iccid: record.iccid
                                        }
                                    });
                                }else{
                                    localStorage.setItem('phoneNo', result.userPhone);
                                    this.$router.replace('/user/home');
                                }
                            }else{
                                Dialog.alert({title: '提示', message:res.data.message});
                            }
                        })
                    }else if(this.suolangList.indexOf(cardType) > -1){
                        window.location.href = `http://wx.iot688.com/iot/iotSimfind?cn=${iccid}&yurlyb=wx.ischenxin.com/#/user/home`
                    }else{
                       this.$router.replace('/user/home');
                    }   
                }else{
                    Dialog.alert({title: '提示', message:res.data.message});
                }
            })
        },


        //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        
        goBuyCard() {
            window.location.href = 'http://xx.ywwltx.com/#/user/login2'
        }

        // goto(path){
        //     //广告点击统计
        //     wxRequest("link/click",{url: path}, "get").then(res => {
        //         window.location.href = path;
        //     });
            
        // },


    },
    created(){
        var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
        localStorage.setItem('appid', source);
        localStorage.setItem('isHeadquarterAppid', false);
        var appid  = source ? source : process.env.VUE_APP_APPID;

        console.log(appid)
        var redirectUrl = window.location.href;   
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
         this.code = '111';
            this.iccid = localStorage.getItem('recordLoginText');
        //获取总部公众号appid
		// wxRequest("/sim/appId",{}, "post").then(res => {
        //     if(res.data.code == 200){
        //         if(appid != res.data.data.collectAppid ){
        //             this.$store.commit('setIsHeadquarterAppid', 'false');
        //             localStorage.setItem('isHeadquarterAppid', false);
        //         }else{
        //             this.$store.commit('setIsHeadquarterAppid', 'true');
        //             localStorage.setItem('isHeadquarterAppid', true);
        //         }      
        //     }
        // });
          this.$store.commit('setIsHeadquarterAppid', 'true');
          localStorage.setItem('isHeadquarterAppid', true);

    },

    mounted() {

    },


    beforeDestory(){
       
    }
}
</script>


<style scoped lang="less">
.big-img {
    text-align: center;
}
.yema-big-img {
    height: 100px;
}
// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }


</style>